export const parseSseBuffer = (rawBuffer) => {
  const normalized = String(rawBuffer || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const records = normalized.split('\n\n');
  const remainder = records.pop() || '';
  const events = [];
  let malformed = 0;

  records.forEach((record) => {
    const line = record.split('\n').find((value) => value.indexOf('data:') === 0);
    if (!line) return;
    try {
      events.push(JSON.parse(line.slice(5).trim()));
    } catch (error) {
      malformed += 1;
    }
  });

  return { events, remainder, malformed };
};

export const readHttpErrorMessage = async (response) => {
  try {
    const text = await response.text();
    if (!text) return 'Unable to start the coding agent.';
    try {
      const data = JSON.parse(text);
      return data.message || data.error || text;
    } catch (error) {
      return text;
    }
  } catch (error) {
    return 'Unable to start the coding agent.';
  }
};
